import React from 'react'
import {
	Dialog,
	DialogContent,
	DialogTitle,
	Box,
	Typography,
	CircularProgress,
	Backdrop,
} from '@mui/material'
import { styled } from '@mui/material/styles'

interface ServerUpdateOverlayProps {
	isVisible: boolean
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialog-paper': {
		backgroundColor: theme.palette.background.paper,
		borderRadius: theme.spacing(2),
		padding: theme.spacing(2),
		minWidth: 320,
		textAlign: 'center',
	},
}))

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
	zIndex: theme.zIndex.modal + 1,
	backgroundColor: 'rgba(0, 0, 0, 0.7)',
}))

const LoadingContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: theme.spacing(3),
	padding: theme.spacing(3),
}))

const SpinnerContainer = styled(Box)(({ theme }) => ({
	position: 'relative',
	display: 'inline-flex',
	marginBottom: theme.spacing(2),
}))

export const ServerUpdateOverlay: React.FC<ServerUpdateOverlayProps> = ({
	isVisible,
}) => {
	return (
		<StyledDialog
			open={isVisible}
			disableEscapeKeyDown
			aria-labelledby="server-update-title"
			aria-describedby="server-update-description"
			BackdropComponent={StyledBackdrop}
			maxWidth="sm"
			fullWidth={false}
		>
			<DialogTitle id="server-update-title">
				<Typography variant="h6" component="div" fontWeight="bold">
					Cloud Update in Progress
				</Typography>
			</DialogTitle>
			<DialogContent>
				<LoadingContainer>
					<SpinnerContainer>
						<CircularProgress
							size={60}
							thickness={4}
							sx={{
								color: (theme) => theme.palette.primary.main,
							}}
						/>
					</SpinnerContainer>
					<Box>
						<Typography
							id="server-update-description"
							variant="body1"
							color="text.primary"
							gutterBottom
						>
							The server is currently being updated.
						</Typography>
						<Typography variant="body2" color="text.secondary">
							Please wait while we apply the latest improvements.
						</Typography>
					</Box>
				</LoadingContainer>
			</DialogContent>
		</StyledDialog>
	)
}
